import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsAssociation,
  UpdateNpsAssociation,
  FiltersNpsAssociations
} from '@/Network/Types/Requests/NpsRequests'
import {
  NpsAssociationResponse,
  ListNpsAssociationsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsAssociationService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/associations'
  }

  async create(payload: CreateNpsAssociation): Promise<NpsAssociationResponse> {
    const response = await request.post<NpsAssociationResponse>(this.getCompletePath(), payload)
    return response.data
  }

  async update(
    associationId: number,
    payload: UpdateNpsAssociation
  ): Promise<NpsAssociationResponse> {
    const response = await request.put<NpsAssociationResponse>(
      `${this.getCompletePath()}/${associationId}`,
      payload
    )
    return response.data
  }

  async getById(associationId: number): Promise<NpsAssociationResponse> {
    const response = await request.get<NpsAssociationResponse>(
      `${this.getCompletePath()}/${associationId}`
    )
    return response.data
  }

  async delete(associationId: number): Promise<void> {
    await request.delete(`${this.getCompletePath()}/${associationId}`)
  }

  async list(filters?: FiltersNpsAssociations): Promise<ListNpsAssociationsResponse> {
    try {
      const { data } = await request.get<ListNpsAssociationsResponse>(
        this.getCompletePath(),
        filters
      )
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }
}
